<div class="body">
    
    <div class="logo">
        <img src="assets/optima_logo.png" style= "width:500px; height: auto; margin-bottom: 20px;">
    </div> 
    <div class="loginCard" *ngIf="changePswForm">
        <h5 style="margin-top: 20px;">{{ 'users.infoPass.mainTitle' | translate }}</h5>
        <form [formGroup]="changePswForm">
            <div class="form-group">
                <label class="roboSubTitle" for="oldPsw">{{ 'users.infoPass.oldPw' | translate }}</label>
                <input [type]="field1.type" class="form-control" id="oldPsw" [placeholder]=" 'users.infoPass.oldPw' | translate" formControlName="oldPsw">
                <span toggle="#oldPsw" class="bi field-icon toggle-password" (click)="changeVisibility(1)"
                [ngClass]="{'bi-eye-slash-fill' : field1.hide, 'bi-eye-fill' : !field1.hide}"></span>
            </div>
            <!--<div class="form-group">
                <label class="roboSubTitle" for="mail">{{ 'users.infoPass.email' | translate }}</label>
                <input type="text" class="form-control" id="mail" placeholder="E-mail" formControlName="mail">
            </div>-->
            <div class="form-group">
                <label class="roboSubTitle" for="newPsw">{{ 'users.infoPass.newPw' | translate }}</label>
                <input [type]="field2.type" class="form-control" id="newPsw" [placeholder]="'users.infoPass.newPw' | translate" formControlName="new_ps">
                <span toggle="#newPsw" class="bi field-icon toggle-password" (click)="changeVisibility(2)"
                [ngClass]="{'bi-eye-slash-fill' : field2.hide, 'bi-eye-fill' : !field2.hide}"></span>
            </div>
            <div class="form-group">
                <label class="roboSubTitle" for="newPsw_conf">{{ 'users.infoPass.confirmPw' | translate }}</label>
                <input [type]="field3.type" class="form-control" id="newPsw_conf" [placeholder]="'users.infoPass.newPw' | translate" formControlName="new_password_conf">
                <span toggle="#newPsw_conf" class="bi field-icon toggle-password" (click)="changeVisibility(3)"
                [ngClass]="{'bi-eye-slash-fill' : field3.hide, 'bi-eye-fill' : !field3.hide}"></span>
            </div>
        </form>
        <div class="error-message" *ngIf="msgError != ''">{{msgError}}</div>
        <button type="button" class="btn btn-primary btnLogin" (click)="changePsw()">{{ 'users.infoPass.continue' | translate }}</button>

        <div class="infoPass">
            <h5>{{ 'users.infoPass.title' | translate }}</h5>
            <ul>
                <li>{{ 'users.infoPass.info1' | translate }}</li>
                <li>{{ 'users.infoPass.info2' | translate }}</li>
                <li>{{ 'users.infoPass.info3' | translate }}</li>
                <li>{{ 'users.infoPass.info4' | translate }}</li>
              </ul>
        </div>
        <div class="logo">
            <img src="assets/logo.png">
        </div>

        <div class="recoveryPsw" style="cursor: pointer;" (click)="router.navigate(['Login'])">
            <img src="assets/icone_varie/arrow_down_blue.png" style="transform: rotate(90deg);">
            <h5 class="roboMenu" >{{ 'login.goToLogin' | translate }}</h5>
        </div>
    </div>
    
</div>